<template>
  <div class="candidate-edit">
    <ModalWindow
      v-if="showDublicateModal"
      @close="showDublicateModal = false"
      class="candidate-modal"
    >
      <CandidateDublicateAttention
        @close="showDublicateModal = false"
        @replaceSuccess="onReplaceSuccess"
      />
    </ModalWindow>
    <div class="candidate-edit__wrapper container">
      <a @click="$router.back()" class="candidate-edit__breadcrumbs">
        <img src="@/assets/images/icons/back-arrow.svg" alt="arrow" />
        <p>Карточка кандидата</p>
      </a>

      <div class="candidate-edit__header">
        <h1 class="candidate-edit__title main-title">
          {{ $route.meta.name }}
        </h1>
      </div>
      <div class="candidate-edit__body">
        <div class="candidate-edit__form">
          <div class="candidate-edit__form-header">
            <h2 class="candidate-edit__form-title">Данные кандидата</h2>
            <VSelect
              class="candidate-edit__form-header-select"
              placeholder="Выберите статус"
              :options="statusOptions"
              v-model="form.status"
            />
          </div>

          <section class="candidate-edit__form-section">
            <h3 class="candidate-edit__form-section-title">Личные данные</h3>
            <div class="candidate-edit__form-row">
              <div class="candidate-edit__form-field">
                <VCustomInput
                  class="candidate-edit__input"
                  placeholder="Фамилия*"
                  :error="v$.second_name.$error"
                  v-model="form.second_name"
                />
                <p
                  class="candidate-edit__form-field-error"
                  v-if="v$.second_name.$error"
                >
                  Заполните обязательное поле
                </p>
              </div>
              <div class="candidate-edit__form-field">
                <VCustomInput
                    class="candidate-edit__input"
                    placeholder="Имя*"
                    :error="v$.first_name.$error"
                    v-model="form.first_name"
                />
                <p
                    class="candidate-edit__form-field-error"
                    v-if="v$.first_name.$error"
                >
                  Заполните обязательное поле
                </p>
              </div>
            </div>
            <div class="candidate-edit__form-row">
              <div class="candidate-edit__form-field">
                <VCustomInput
                    class="candidate-edit__input"
                    placeholder="Отчество*"
                    :error="v$.parent_name.$error"
                    v-model="form.parent_name"
                />
                <p
                    class="candidate-edit__form-field-error"
                    v-if="v$.parent_name.$error"
                >
                  Заполните обязательное поле
                </p>
              </div>
              <div class="candidate-resume__form-field">
                <VSelect
                    class="candidate-resume__input"
                    placeholder="Пол*"
                    :error="v$.gender.$error"
                    :options="genderOptions"
                    v-model="form.gender"
                />
                <p
                    class="candidate-resume__form-field-error"
                    v-if="v$.gender.$error"
                >
                  Заполните обязательное поле
                </p>
              </div>
            </div>
            <div class="candidate-edit__form-row">
              <div class="candidate-edit__form-field">
                <VCustomInput
                  class="candidate-edit__input"
                  placeholder="Дата рождения*"
                  v-model="form.birthdate"
                  v-mask="'00.00.0000'"
                />
                <p
                  class="candidate-edit__form-field-error"
                  v-if="v$.birthdate.$error"
                >
                  Заполните обязательное поле
                </p>
              </div>
              <div class="candidate-resume__form-field">
                <VNationalityField
                    class="candidate-resume__input"
                    placeholder="Гражданство*"
                    :error="v$.nationality.$error"
                    v-model="form.nationality"
                />
              </div>
            </div>
            <div class="candidate-edit__form-field">
              <VSearchSelectCity
                  class="candidate-edit__select"
                  placeholder="Город проживания*"
                  :error="v$.residence.$error"
                  @selectItem="onSelectResidence"
                  v-model="form.residence.name"
              />
              <p
                  class="candidate-edit__form-field-error"
                  v-if="v$.residence.$error"
              >
                Заполните обязательное поле
              </p>
            </div>
          </section>
          <section class="candidate-edit__form-section">
            <h3 class="candidate-edit__form-section-title">
              Контактные данные
            </h3>
            <div class="candidate-edit__form-row">
              <div class="candidate-edit__form-field">
                <VCustomInput
                  class="candidate-edit__input candidate-edit__input_disabled"
                  placeholder="Телефон*"
                  v-model="form.phone"
                  v-mask="'+0(000) 000-00-00'"
                  type="text"
                  name="mask"
                />
                <p
                  class="candidate-edit__form-field-error"
                  v-if="v$.phone.$error"
                >
                  Заполните обязательное поле
                </p>
              </div>
              <div class="candidate-edit__form-field">
                <VCustomInput
                  class="candidate-edit__select"
                  placeholder="Почта"
                  v-model="form.email"
                />
                <p
                  class="candidate-edit__form-field-error"
                  v-if="v$.email.$error"
                >
                  Введите корректный email
                </p>
              </div>
            </div>
          </section>
          <section class="candidate-edit__form-section">
            <h3 class="candidate-edit__form-section-title">
              Дополнительные данные
            </h3>
            <div class="candidate-edit__form-row">
              <VCustomInput
                class="candidate-edit__select"
                placeholder="Стаж (лет)"
                v-model="form.work_experience"
              />
              <VSelect
                class="candidate-edit__select"
                placeholder="Источник"
                :options="sourceOptions"
                v-model="form.source"
              />
            </div>
            <div class="candidate-edit__form-row_full">
              <VTagsInputSelect
                  class="candidate-edit__select"
                  placeholder="Метки"
                  :options="labelsOptions"
                  :isWithoutCheckmarks="true"
                  v-model="form.labels"
              />
            </div>
            <div class="candidate-edit__form-row_full">
              <VTagsInputSelect
                class="candidate-edit__select"
                placeholder="Специальности"
                :options="specialtyOptions"
                :isWithoutCheckmarks="true"
                v-model="form.specialities"
              />
            </div>
          </section>

          <section class="candidate-create__form-section">
            <h3 style="margin-bottom: 16px" class="candidate-edit__form-section-title">
              Файлы
            </h3>
            <VAddFiles
                style="margin-top: 16px"
                v-model="documents_for_sign_in_id"
                :valueIn="documents_for_sign_in"
                set-padding="0"
            />
          </section>

          <section class="candidate-edit__form-section">
            <h3 class="candidate-edit__form-field-title">
              Комментарий по кандидату
            </h3>
            <p class="candidate-edit__form-field-label">
              Не более 2000 символов
            </p>
            <div class="candidate-edit__form-textarea">
              <VEditor
                placeholder="Напишите комментарий"
                v-model="form.comment"
                id="description"
                class="basic-information__editor"
              />
            </div>
          </section>
        </div>
      </div>

      <ResponsibleManager :key="form.responsible_hr" v-model="form.responsible_hr" :error="v$.responsible_hr.$error"/>

      <div class="candidate-edit__btns">
        <VButtonNew
          label="Отменить"
          style-type="grey"
          class="candidate-edit__btn"
          link
          :to="`/candidates/${route?.params?.id}`"
        />

        <VButtonNew
          label="Сохранить"
          class="candidate-edit__btn"
          @click="saveCandidate"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, onMounted, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import candidates from "@/api/candidates";
import common from "@/api/common";
import useVuelidate from "@vuelidate/core";
import { required, email } from "@vuelidate/validators";
import VTagsInputSelect from "@/components/UI/VTagsInputSelect";
import CandidateDublicateAttention from "@/components/ModalWindow/ModalBodyes/CandidateDublicateAttention";
import useOffsetTop from "@/hooks/getOffsetTopScroll";
import { debounce } from "./../../services/helpers";
import BasicInformation from "@/components/CreateVacancy/BasicInformation/index.vue";
import ResponsibleManager from "@/components/CreateVacancy/ResponsibleManager/index.vue";
import VSearchSelectCity from "@/components/UI/VSearchSelect/City.vue";
import VNationalityField from "@/components/UI/DataFields/VNationalityField/index.vue";
import VAddFiles from "@/components/UI/VAddFiles.vue";
import sources from "@/api/sources";

const router = useRouter();
const route = useRoute();
const customRouteLink = ref(`${route.matched[0].path}/${route.params.id}`);
const editId = route.params.id;
const isShowModal = ref(false);
const showDublicateModal = ref(false);
const showReplaceModal = ref(false);
const form = reactive({
  first_name: "",
  second_name: "",
  parent_name: "",
  gender: "male",
  birthdate: "",
  nationality: "",
  responsible_hr: null,
  residence: {
    name: "",
  },
  residence_id: null,
  phone: "",
  email: "",
  specialty: "",
  work_experience: "",
  status: "",
  labels: "",
  source: "",
  comment: `<p></p>`,
  files: [],
});
const documents_for_sign_in_id = ref([])
const documents_for_sign_in = ref([])

const rules = computed(() => ({
  first_name: { required },
  second_name: { required },
  parent_name: { required },
  nationality: { required },
  gender: { required },
  birthdate: { required },
  residence: { required },
  responsible_hr: { required },
  phone: { required },
  email: { email },
}));

const v$ = useVuelidate(rules, form);

const genderOptions = [
  {
    id: "male",
    label: "Мужчина",
  },
  {
    id: "female",
    label: "Женщина",
  },
];

const statusOptions = ref([]);
const sourceOptions = ref([]);
const labelsOptions = ref([]);
const specialtyOptions = ref([]);

const onGenderUpdate = (val) => {
  form.gender = val;
};
const saveCandidate = async () => {
  const validate = await v$.value.$validate();

  if (!validate) {
    useOffsetTop();
    return;
  }
  form.files = documents_for_sign_in_id.value
  const { phone, ...filteredForm } = form;

  candidates.updateCandidate(route.params?.id, filteredForm).then((res) => {
    router.push(`/candidates/${route.params?.id}`);
  });
};

const onSelectResidence = (item) => {
  form.residence_id = item?.id;
  form.residence.name = item?.name;
};

const onReplaceSuccess = () => {
  showReplaceModal.value = true;
};

onMounted(async () => {
  candidates.getCandidate(route.params?.id).then((res) => {
    if (res?.data) {
      for (const key in res?.data) {
        if (key === "residence") {
          form.residence.name = res?.data?.residence?.name
            ? `${
                res?.data?.residence?.regionDescription
                  ? res?.data?.residence?.regionDescription + ", "
                  : ""
              }${res?.data?.residence?.name}`
            : "";
        } else {
          form[key] = res?.data[key];
        }
      }
      form.first_name = res.data?.name?.first;
      form.second_name = res.data?.name?.second;
      form.parent_name = res.data?.name?.parent;
      form.nationality = res.data?.nationality?.code;
      form.residence_id = res?.data?.residence?.id;
      form.responsible_hr = res?.data?.responsible_hr?.id;
      res?.data?.files?.forEach((file) => {
        documents_for_sign_in_id.value.push(file.id);
        documents_for_sign_in.value.push(file);
      })
    }
  });

  candidates.getStatuses().then((res) => {
    statusOptions.value = res?.data?.statuses?.map((option, index) => ({
      id: option,
      label: option,
    }));
  });

  sourceOptions.value = await sources.getSources()
  sourceOptions.value = sourceOptions.value?.map((option, index) => ({
    id: option.name,
    label: option.name,
  }))

  candidates.getLabels().then((res) => {
    labelsOptions.value = res?.data?.labels;
  });

  candidates.getSpecialities().then((res) => {
    specialtyOptions.value = res?.data?.specialities;
  });
});
</script>

<style scoped lang="scss">
.candidate-modal {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 40px 24px 24px;

  &__close {
    position: absolute;
    top: 16px;
    right: 16px;
    cursor: pointer;
  }

  &__icon {
    height: 56px;
    width: 56px;
    flex: 0 0 auto;
    align-self: center;
    margin-bottom: 16px;
  }

  &__title {
    margin-bottom: 8px;
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    line-height: 24.2px;
  }

  &__description {
    margin-bottom: 24px;
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    line-height: 20.8px;
  }
  &__button {
    &:not(:last-child) {
      margin-bottom: 12px;
    }
  }
}

.candidate-edit {
  padding-bottom: 45px;

  :deep(.modal__body) {
    width: 352px;
  }

  :deep(.v-filtration) {
    border-radius: 4px;
    background-color: $light;
  }
  :deep(.v-filtration__filter) {
    width: 186px;
    border-radius: 4px;
  }

  &__wrapper {
    padding-top: 14px;
  }

  &__breadcrumbs {
    display: flex;
    align-items: center;
    color: $gray;
    text-decoration: none;
    cursor: pointer;
    user-select: none;

    p {
      margin-left: 4px;
      font-size: 14px;
      font-weight: 400;
    }

    img {
      width: 20px;
    }
  }

  &__header {
    margin-top: 8px;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__form {
    padding: 24px;
    background-color: #fff;
    border-radius: 16px;
  }

  &__input {
    width: 100%;
    &_disabled {
      pointer-events: none;
      user-select: none;
      color: $dark-blue;
      :deep(.v-input__input) {
        color: $dark-blue;
      }
    }
  }

  &__form-field {
    :deep(.v-input) {
      width: 100%;
    }
  }

  &__form-field-error {
    margin-top: 4px;
    font-size: 14px;
    color: $red;
  }

  &__form-header {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    border-bottom: 1px solid #e4e7ee;
  }

  &__form-header-select {
    flex: 0 1 224px;
    :deep(.v-select__header) {
      width: 224px;
      height: 44px;
      background-color: #f0f2f4;
    }
    :deep(.v-select__header-palceholder) {
      color: $gray;
    }

    :deep(.v-select__header_selected .v-select__header-palceholder) {
      display: none;
    }

    :deep(.v-select__header_selected .v-select__header-value) {
      top: 16px;
    }
  }

  &__form-title {
    flex: 1 1 50%;
    font-size: 20px;
    font-weight: 500;
  }
  &__form-section {
    margin-top: 20px;
  }
  &__form-section-title {
    margin-bottom: 20px;
    font-size: 16px;
    font-weight: 500;
    line-height: 19.36px;
    text-align: left;
  }

  &__form-field-title {
    margin-bottom: 4px;
    font-size: 16px;
    font-weight: 500;
    line-height: 19.36px;
    text-align: left;
  }

  &__form-field-label {
    margin-bottom: 16px;
    color: $gray;
    font-size: 14px;
    font-weight: 400;
    line-height: 16.94px;
    text-align: left;
  }

  &__form-textarea {
    :deep(.v-editor__editor) {
      height: 240px;
    }
  }

  &__form-row {
    display: flex;
    gap: 16px;
    margin-bottom: 16px;
    & div {
      flex: 0 1 calc(50% - 8px);
    }
    &_full {
      margin-bottom: 16px;
    }
  }

  &__btns {
    width: 100%;
    margin-top: 24px;
    display: flex;
    justify-content: space-between;
  }

  &__btn {
    &:first-child {
      width: 42.307%;
    }

    &:last-child {
      width: 53.846%;
    }
  }
}
</style>
